import { VehicleRelatedDto } from "@1games-ru/region-shared/dist/types/vehicle/vehicle.v3";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export async function fetchVehiclesRelated(): Promise<VehicleRelatedDto[]> {
  const res = await VehicleMpProvider.getRelated();

  if (res instanceof RpcMpProviderFailedResponse) {
    throw new Error(res.message ?? "Failed to load vehicles");
  }
  return res.data;
}
